import React from "react";
import verificationIcon from "../../images/andus-central-access-email-verification-icon.svg";

export default function VerificationPanel({
  email,
  onContinue,
  onResend,
  busy,
  continueLabel = "I have verified my email",
  note = "Open the email from Firebase, verify your address, then return here to continue.",
}) {
  return (
    <div className="pa-verification-panel">
      <img src={verificationIcon} alt="" aria-hidden="true" />
      <p>Verification email sent to</p>
      <strong>{email}</strong>
      <span>{note}</span>
      <button className="pa-primary-button" type="button" onClick={onContinue} disabled={busy}>
        <span>{busy ? "Checking…" : continueLabel}</span><span aria-hidden="true">›</span>
      </button>
      <button className="pa-text-button" type="button" onClick={onResend} disabled={busy}>Resend verification email</button>
    </div>
  );
}

